import { render, staticRenderFns } from "./product_apply.vue?vue&type=template&id=c60c851c"
import script from "./product_apply.vue?vue&type=script&lang=js"
export * from "./product_apply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports